export default __webpack_public_path__ + "static/media/fallback-avatar.daa88bcd.png";